export const CAMP_PHOTO_DEFAULT_FALLBACK = "/photos/categories/general.webp";

const CATEGORY_STOCK_PHOTO_LOOKUP_ALIASES: Record<string, string> = {
  adaptive: "special-needs",
  art: "arts-crafts",
  dance: "performing-arts",
  gaming: "stem",
  mixed: "general",
  "multi-activity": "general",
  music: "performing-arts",
  nature: "outdoors-nature",
  outdoor: "outdoors-nature",
  reading: "enrichment",
  sport: "sports",
  tech: "stem",
  "team-building": "general",
};

export const CATEGORY_STOCK_PHOTOS: Record<string, string> = {
  academic: "/photos/categories/academic.webp",
  "arts-crafts": "/photos/categories/arts-crafts.webp",
  enrichment: "/photos/categories/enrichment.webp",
  general: "/photos/categories/general.webp",
  "outdoors-nature": "/photos/categories/outdoors-nature.webp",
  "performing-arts": "/photos/categories/performing-arts.webp",
  "special-needs": "/photos/categories/special-needs.webp",
  sports: "/photos/categories/sports.webp",
  stem: "/photos/categories/stem.webp",
};

export const SUPPORTED_CAMP_STOCK_PHOTO_CATEGORIES = Object.keys(
  CATEGORY_STOCK_PHOTOS,
).sort();

export const NON_CAMP_STOCK_PHOTO_CATEGORIES = ["childcare", "medical-health"] as const;

export const SUBCATEGORY_STOCK_PHOTOS: Record<string, string> = {
  "academic__college-prep": "/photos/categories/academic__college-prep.webp",
  "academic__reading-writing": "/photos/categories/academic__reading-writing.webp",
  "academic__study-skills": "/photos/categories/academic__study-skills.webp",
  "academic__test-prep": "/photos/categories/academic__test-prep.webp",
  "academic__tutoring": "/photos/categories/academic__tutoring.webp",
  "arts-crafts__ceramics-pottery": "/photos/categories/arts-crafts__ceramics-pottery.webp",
  "arts-crafts__digital-art": "/photos/categories/arts-crafts__digital-art.webp",
  "arts-crafts__fiber-arts": "/photos/categories/arts-crafts__fiber-arts.webp",
  "arts-crafts__film-video": "/photos/categories/arts-crafts__film-video.webp",
  "arts-crafts__mixed-media": "/photos/categories/arts-crafts__mixed-media.webp",
  "arts-crafts__photography": "/photos/categories/arts-crafts__photography.webp",
  "arts-crafts__visual-arts": "/photos/categories/arts-crafts__visual-arts.webp",
  "arts-crafts__woodworking": "/photos/categories/arts-crafts__woodworking.webp",
  "enrichment__chess": "/photos/categories/enrichment__chess.webp",
  "enrichment__cooking-baking": "/photos/categories/enrichment__cooking-baking.webp",
  "enrichment__debate": "/photos/categories/enrichment__debate.webp",
  "enrichment__language": "/photos/categories/enrichment__language.webp",
  "enrichment__leadership": "/photos/categories/enrichment__leadership.webp",
  "enrichment__life-skills": "/photos/categories/enrichment__life-skills.webp",
  "general__before-after-care": "/photos/categories/general__before-after-care.webp",
  "general__drop-in": "/photos/categories/general__drop-in.webp",
  "general__overnight-camp": "/photos/categories/general__overnight-camp.webp",
  "general__traditional-day-camp": "/photos/categories/general__traditional-day-camp.webp",
  "outdoors-nature__camping-backpacking": "/photos/categories/outdoors-nature__camping-backpacking.webp",
  "outdoors-nature__fishing": "/photos/categories/outdoors-nature__fishing.webp",
  "outdoors-nature__gardening": "/photos/categories/outdoors-nature__gardening.webp",
  "outdoors-nature__hiking": "/photos/categories/outdoors-nature__hiking.webp",
  "outdoors-nature__horseback-riding": "/photos/categories/outdoors-nature__horseback-riding.webp",
  "outdoors-nature__mountain-biking": "/photos/categories/outdoors-nature__mountain-biking.webp",
  "outdoors-nature__paddling": "/photos/categories/outdoors-nature__paddling.webp",
  "outdoors-nature__wilderness-skills": "/photos/categories/outdoors-nature__wilderness-skills.webp",
  "outdoors-nature__wildlife-ecology": "/photos/categories/outdoors-nature__wildlife-ecology.webp",
  "performing-arts__circus-arts": "/photos/categories/performing-arts__circus-arts.webp",
  "performing-arts__dance": "/photos/categories/performing-arts__dance.webp",
  "performing-arts__improv-comedy": "/photos/categories/performing-arts__improv-comedy.webp",
  "performing-arts__music-band": "/photos/categories/performing-arts__music-band.webp",
  "performing-arts__theater-drama": "/photos/categories/performing-arts__theater-drama.webp",
  "special-needs__adaptive-sports": "/photos/categories/special-needs__adaptive-sports.webp",
  "special-needs__sensory-friendly": "/photos/categories/special-needs__sensory-friendly.webp",
  "special-needs__social-skills": "/photos/categories/special-needs__social-skills.webp",
  "special-needs__therapeutic-recreation": "/photos/categories/special-needs__therapeutic-recreation.webp",
  "sports__archery": "/photos/categories/sports__archery.webp",
  "sports__baseball-softball": "/photos/categories/sports__baseball-softball.webp",
  "sports__basketball": "/photos/categories/sports__basketball.webp",
  "sports__cheer": "/photos/categories/sports__cheer.webp",
  "sports__climbing": "/photos/categories/sports__climbing.webp",
  "sports__cycling": "/photos/categories/sports__cycling.webp",
  "sports__fencing": "/photos/categories/sports__fencing.webp",
  "sports__flag-football": "/photos/categories/sports__flag-football.webp",
  "sports__golf": "/photos/categories/sports__golf.webp",
  "sports__gymnastics": "/photos/categories/sports__gymnastics.webp",
  "sports__hockey": "/photos/categories/sports__hockey.webp",
  "sports__lacrosse": "/photos/categories/sports__lacrosse.webp",
  "sports__martial-arts": "/photos/categories/sports__martial-arts.webp",
  "sports__multi-sport": "/photos/categories/sports__multi-sport.webp",
  "sports__skateboarding": "/photos/categories/sports__skateboarding.webp",
  "sports__skiing-snowboarding": "/photos/categories/sports__skiing-snowboarding.webp",
  "sports__soccer": "/photos/categories/sports__soccer.webp",
  "sports__swimming": "/photos/categories/sports__swimming.webp",
  "sports__tennis": "/photos/categories/sports__tennis.webp",
  "sports__track-field": "/photos/categories/sports__track-field.webp",
  "sports__volleyball": "/photos/categories/sports__volleyball.webp",
  "sports__wrestling": "/photos/categories/sports__wrestling.webp",
  "stem__coding-programming": "/photos/categories/stem__coding-programming.webp",
  "stem__engineering-building": "/photos/categories/stem__engineering-building.webp",
  "stem__maker-fabrication": "/photos/categories/stem__maker-fabrication.webp",
  "stem__math": "/photos/categories/stem__math.webp",
  "stem__robotics": "/photos/categories/stem__robotics.webp",
  "stem__science-lab": "/photos/categories/stem__science-lab.webp",
  "stem__space-astronomy": "/photos/categories/stem__space-astronomy.webp",
};

function findStockPhotoBySubcategorySlug(subcategorySlug: string): string | null {
  const suffix = `__${subcategorySlug}`;
  const match = Object.entries(SUBCATEGORY_STOCK_PHOTOS).find(([key]) =>
    key.endsWith(suffix),
  );
  return match?.[1] ?? null;
}

function normalizeSlugList(slugs?: string[] | null): string[] {
  if (!slugs) return [];

  const seen = new Set<string>();
  const normalized: string[] = [];

  for (const slug of slugs) {
    const trimmed = slug?.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    normalized.push(trimmed);
  }

  return normalized;
}

export function pickStockCampPhotoSubcategorySlug({
  categorySlug,
  subjectSlugs,
  formatSlugs,
  subcategorySlugs,
  preferredSubcategorySlug,
}: {
  categorySlug?: string | null;
  subjectSlugs?: string[] | null;
  formatSlugs?: string[] | null;
  subcategorySlugs?: string[] | null;
  preferredSubcategorySlug?: string | null;
}): string | null {
  const category = categorySlug?.trim();
  const resolvedCategory = category
    ? CATEGORY_STOCK_PHOTO_LOOKUP_ALIASES[category] ?? category
    : null;
  const subjects = normalizeSlugList(subjectSlugs);
  const formats = new Set(normalizeSlugList(formatSlugs));
  const remainingSubcategories = normalizeSlugList(subcategorySlugs).filter(
    (slug) => !formats.has(slug),
  );
  const preferred = preferredSubcategorySlug?.trim()
    ? [preferredSubcategorySlug.trim()]
    : [];
  const orderedCandidates = normalizeSlugList([
    ...subjects,
    ...preferred,
    ...remainingSubcategories,
  ]);

  for (const slug of orderedCandidates) {
    if (resolvedCategory && SUBCATEGORY_STOCK_PHOTOS[`${resolvedCategory}__${slug}`]) {
      return slug;
    }
    if (!resolvedCategory && findStockPhotoBySubcategorySlug(slug)) {
      return slug;
    }
  }

  return null;
}

export function getStockCampPhoto({
  categorySlug,
  subcategorySlug,
}: {
  categorySlug?: string | null;
  subcategorySlug?: string | null;
}): string {
  const category = categorySlug?.trim();
  const resolvedCategory = category
    ? CATEGORY_STOCK_PHOTO_LOOKUP_ALIASES[category] ?? category
    : null;
  const subcategory = subcategorySlug?.trim();
  if (subcategory) {
    if (resolvedCategory) {
      const subcategoryPhoto =
        SUBCATEGORY_STOCK_PHOTOS[`${resolvedCategory}__${subcategory}`];
      if (subcategoryPhoto) return subcategoryPhoto;
    } else {
      const subcategoryPhoto = findStockPhotoBySubcategorySlug(subcategory);
      if (subcategoryPhoto) return subcategoryPhoto;
    }
  }
  if (resolvedCategory) {
    const categoryPhoto = CATEGORY_STOCK_PHOTOS[resolvedCategory];
    if (categoryPhoto) return categoryPhoto;
  }
  return CAMP_PHOTO_DEFAULT_FALLBACK;
}
